import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play-alt",
  "use": "icon-play-alt-usage",
  "viewBox": "0 0 8 9",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 9\" id=\"icon-play-alt\"><path d=\"M7.5 3.634a1 1 0 0 1 0 1.732l-6 3.464A1 1 0 0 1 0 7.964V1.036A1 1 0 0 1 1.5.17l6 3.464Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol